<template>
  <div>
    <b-row class="mb-2"
      ><b-col md="10"> <h3>Business Plan</h3> </b-col
      ><b-col md="2"
        ><b-button
          variant="primary"
          class="profile-btn"
          @click="
            $router.push({
              name: 'Add Business Plan',
            })
          "
          >Add Business Plan
        </b-button>
        <router-link to="/businessPlan">
            <eb-button
                style="float: right"
                classic="mr-1 btn-primary"
                text="Back"
              ></eb-button>
            </router-link>
        </b-col
      ></b-row
    >
    <b-card>
      <b-row v-if="loading">
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </b-row>
      <b-container v-if="!loading" class="price mt-2">
        <b-row>
          <b-col md="4" v-for="(item, k) in paginatedBusinessPlanList" :key="k"
            ><b-card
              :class="`${
                stylesArray[Math.floor(Math.random() * stylesArray.length)]
              } price-2`"
            >
              <div>
                <v-avatar size="70">
                  <img :src="item.image" class="image" />
                </v-avatar>
                <h1></h1>
                <span class="plan">{{ item.plan_name }}</span>
              </div>
              <p class="text-dark mt-2">
                {{ item.description.slice(0, 75) + "...." }}
              </p>
              <h4 v-if="item.features.length > 0">Features Included</h4>
              <p
                class="text-dark"
                v-for="(item1, k) in item.features.slice(0, 4)"
                :key="k"
              >
                <i class="fa fa-check check" aria-hidden="true"></i>
                {{ item1.name }}
              </p>
              <b-button
                class="trial-btn mt-3"
                @click="
                  $router.push({
                    name: 'View Business Plan',
                    params: { id: item._id },
                  })
                "
                >View More</b-button
              >
              <div
                class="price text-center d-flex flex-column mt-2"
                v-if="
                  item &&
                  item.subscriptions &&
                  item.subscriptions.length &&
                  item.subscriptions[item.subscriptions.length - 1].pricing
                "
              >
                <h3>
                  ₹
                  {{ totalPrice(item.subscriptions) }}
                  / month
                </h3>
              </div>
            </b-card></b-col
          >
        </b-row>
        <div style="float: right">
          <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="totalBusinessPlans"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
        </div>
      </b-container></b-card
    >
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      loading: false,
      stylesArray: ["class1", "class2", "class3", "class4", "class5", "class6"],
      currentPage: 1,
      perPage: 6,
    };
  },
  computed: {
    ...mapGetters({
      businessPlanList: "businessPlan/GetBusinessPlanList",
    }),
    totalBusinessPlans() {
      return this.businessPlanList.length;
    },
    paginatedBusinessPlanList() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.businessPlanList.slice(start, end);
    },
  },
  methods: {
    ...mapActions({ fetchBusinessPlanList: "businessPlan/businessPlanList" }),
    totalPrice(item) {
      let total = 0;
      total = item.reduce((acc, item) => {
        return acc + item.pricing;
      }, 0);
      return total;
    },
  },

  async mounted() {
    this.loading = true;
    await this.fetchBusinessPlanList();
    this.loading = false;
  },
};
</script>
<style>
.profile-btn {
  height: 38px;
  width: 144px;
  font-size: 13px;
  background-color: #3242f0;
}
.plan {
  font-size: 20px;
  font-weight: 300;
  margin-left: 20px;
}
.image {
  background: rgba(255, 255, 255, 0.72);
}
.trial-card {
  background-color: #fff0d6;
  height: 450px;
}

.trial-btn {
  background-color: #f8931d;
  color: #dee3ea;
  margin-left: 65px;
  border: 0px;
  width: 144px;
}
.trial-btn:hover {
  background-color: #3242f0;
}
.enterpriseAccount-card {
  background-color: #d4e5ff;
  height: 450px;
}

.enterpriseAccount-btn {
  background-color: #00c0f1;
  color: #dee3ea;
  margin-left: 60px;
  border: 0px;
  width: 144px;
}

.smb-card {
  background-color: #ffd9da;
  height: 450px;
}

.smb-btn {
  background-color: #a764a9;
  color: #dee3ea;
  margin-left: 60px;
  border: 0px;
  width: 144px;
}

.smallBusiness-card {
  background-color: #d9ffe5;
  height: 450px;
}

.smallBusiness-btn {
  background-color: #8ec641;
  color: #dee3ea;
  margin-left: 60px;
  border: 0px;
  width: 144px;
}

.startup-card {
  background-color: #ccecff;
  height: 450px;
}

.startup-btn {
  background-color: #0073b9;
  color: #dee3ea;
  margin-left: 60px;
  border: 0px;
  width: 144px;
}
.price {
  margin-top: 20px;
}
.price-2 {
  margin-top: -35px;
  margin-bottom: 50px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  height: 500px;
  border-radius: 10px;
}
.check {
  color: #42b039;
}
.class1 {
  background: #fff0d6;
  border: 1px solid #ececec;
}

.class2 {
  background: #ececec;
  border: 1px solid #ececec;
}

.class3 {
  background: #f9d1f7;
  border: 1px solid #ececec;
}

.class4 {
  background: #d9ddf9;
  border: 1px solid #ececec;
}
.class5 {
  background: #d3f4da;
  border: 1px solid #ececec;
}
.class6 {
  background: #edf5a3;
  border: 1px solid #ececec;
}
</style>
